import axios from "axios";
import { Procedure } from "../../types/model/procedure";
import { SessionStore } from "../../types/store/SessionStore";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/project`;

export const getProcedure = async (
  projectId: number,
  activityId: number,
  procedureId: number,
): Promise<Procedure> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const finalURL =
    BASE_URL +
    "/" +
    projectId +
    "/activity/" +
    activityId +
    "/procedure/" +
    procedureId;

  return await axios
    .get<Procedure>(finalURL, {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            )
          : AbortSignal.timeout(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            ),
    })
    .then((response) => response.data);
};
